import React, { Fragment } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Hero from './Hero';
import Vision from '../images/svg/vision.svg';
import Mission from '../images/svg/goal.svg';

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '20px 0',
    },
    heroContent: {
        width: '60%',
        margin: '0 auto',
        padding: '20px 0',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    heroHeader: {
        fontSize: '50px',
        fontWeight: '400',
        color: '#FFFFFF',
        textAlign: 'center',
        margin: '120px 0 20px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px',
            margin: '60px 0 20px 0',
        },
        '&::after': {
            display: 'block',
            width: '2.5em',
            height: '3px',
            background: '#51e3d4',
            content: '" "',
            margin: '7px auto',
            borderRadius: '2px'
        }
    },
    heroText: {
        fontSize: '20px',
        margin: '20px 0 120px 0',
        color: '#FFFFFF',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '17px',
            margin: '20px 0 60px 0',
        },
    },
    visionMissionSection: {
        width: '90%',
        margin: '30px auto',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            margin: '20px auto',
        },
    },
    imageSection: {
        textAlign: 'center',
        margin: '20px 0'
    },
    visionMissionImage: {
        width: '35%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '45%',
        },
    },
    goalText: {
        marginBottom: '40px',
        [theme.breakpoints.up('sm')]: {
            padding: '0 30px'
        }
    },
    textHeading: {
        margin: '15px 0',
        fontSize: '30px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    textDescription: {
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    card: {
        padding: '6px',
    },
    cardSection: {
        margin: '0 auto',
        padding: '20px 0',
        backgroundColor: '#f2f4fb',
        textAlign: 'center'
    },
    standOutContainer: {
        width: '90%',
        margin: '0 auto 60px auto',
        padding: '20px 0',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto 20px auto'
        }
    },
    cardHeading: {
        fontSize: '23px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
        '&::after': {
            display: 'block',
            width: '3em',
            height: '3px',
            background: '#51e3d4',
            content: '" "',
            margin: '7px auto',
            borderRadius: '2px'
        }
    }
});

const privilegeList = [
    {
        heading: "Liability",
        description: "Admitting and accepting responsibility for decisions, actions for work and policies for employees as well as the company as a whole."
    },
    {
        heading: "Passion For Excellence",
        description: "Everyday for us is a chance to create greatness and succeed at something, passion for excellence starts with our employees and extends to our partners."
    },
    {
        heading: "Listen, Care And Serve",
        description: "We continue to train, grow and develop our talent to meet our growth opportunities and stay focused on our values to deliver client expectations."
    },
    {
        heading: "Collaboration",
        description: "We believe in unity. When there is teamwork and collaboration wonderful things can be achieved. We understand our clients needs and collaboratively achieves it."
    },
    {
        heading: "Continuous Learning",
        description: "We value the curiosity to learn and explore new trends in user demand driven services so that we can continue to be challenged and inspired."
    },
    {
        heading: "Transparency",
        description: "Our trust is built through dedicated work and transparent communication for all levels of action, work and engagement we deal."
    }
]

const About = (props) => {
    const { classes } = props;
    return (
        <Fragment>
            <Hero image="office_banner.jpg">
                <div className={classes.heroContent}>
                    <Typography variant="h1" className={classes.heroHeader}>About Us</Typography>
                    <Typography variant="body1" className={classes.heroText}>Asyncentric is a Software development and Testing company, offering peer business solutions. We provide comprehensive professional services in software development across web-driven software solutions and products, mobile app development and maintenance of developed applications. </Typography>
                </div>
            </Hero>
            <section className={classes.container}>
                <div className={classes.visionMissionSection}>
                    <Grid container spacing={32}>
                        <Grid container item xs={12} sm={6}>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.imageSection}>
                                    <img src={Vision} alt="Vision" className={classes.visionMissionImage} />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.goalText}>
                                    <Typography variant="h4" className={classes.textHeading}>Our Vision</Typography>
                                    <Typography variant="body1" className={classes.textDescription}>To be a leading global provider for end-to-end IT solutions and a “go-to” partner for those we serve, with most agile response to the customer requirements.</Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} sm={6}>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.imageSection}>
                                    <img src={Mission} alt="Mission" className={classes.visionMissionImage} />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.goalText}>
                                    <Typography variant="h4" className={classes.textHeading}>Our Mission</Typography>
                                    <Typography variant="body1" className={classes.textDescription}>To engineer meaningful technology solutions by skillfully applying the most sought after, fast growing pertinent technologies at a price point enviable by others.</Typography>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <section className={classes.cardSection}>
                <div className={classes.standOutContainer}>
                    <Typography variant="h3" className={classes.textHeading}>Why We Stand Out</Typography>
                    <br /><br />
                    <Grid container spacing={24}>
                        {
                            privilegeList.map((item, index) => {
                                return <Grid key={index} item xs={12} sm={4}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Typography gutterBottom variant="h4" className={classes.cardHeading}>
                                                {item.heading}</Typography>
                                            <Typography variant="body1" className={classes.textDescription}>
                                                {item.description}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            })
                        }
                    </Grid>
                </div>
            </section>
        </Fragment>
    );
}

About.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(About);